// @ts-check
import { IS_DEVELOPMENT } from '../common/constants';

/**
 * Logs an error message to the console in a development environment.
 * @param {any} message - The error message to be logged.
 */
export function logError(message) {
  if (!IS_DEVELOPMENT) {
    return;
  }

  // eslint-disable-next-line no-console
  console.error(message);
}
